<template>
  <div class="card-base card-shadow--medium mb-10 widget small-widget">
    <div class="widget-header p-20">
      <div class="flex justify-center align-center">
        <!-- Caja de icono izquierda -->
        <div class="widget-icon-box mr-20 animated fadeInRight">
          <i class="widget-icon fs-30" :class="icon"></i>
        </div>
        <!-- caja central -->
        <div class="widget-info box grow text-truncate animated fadeInLeft">
          <div class="o-050 widget-title text-center text-truncate pt-5 pb-10">
            {{ title }}
          </div>
          <h2 class="m-0 text-center text-truncate">{{ val }}</h2>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CardStat",
  props: {
    icon: {
      type: String,
      default: "mdi mdi-account-multiple"
    },
    title: {
      type: String,
      required: true
    },
    val: {
      type: [Number, String]
    }
  }
};
</script>
